import React from 'react';
import { getDomainLogo } from '../utils/domainConfig';

const logo = getDomainLogo();

const Loading = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999]">
      <div className="relative flex items-center justify-center w-28 h-28">
        {/* spinning ring */}
        <span
          className="absolute w-20 h-20 rounded-full border-4 border-slate-200 border-t-[var(--accent)]"
          style={{ animation: 'spin 0.9s linear infinite' }}
        />
        <img
          src={logo}
          alt="Loading"
          className="w-10 h-10"
          style={{ animation: 'pulse 1.6s ease-in-out infinite' }}
        />
      </div>
    </div>
  );
};

export default Loading;
